export const environment = {
  production: true,
  version: '1.1.116', //should match the one in the package json file
  apiURL: 'https://api.stag.rockwell-logic.ie/api',
  ga_measurement_id: 'G-2N15JPF1YT',
  cryptoKey: '6360abf9187a95952b67870a128d91df9c84797843f2569376738eb49135de0392c1971d2e9d911d5aad3064585fad31d9c11d175364de34740d7aebc7de85019e3441f997b7071ccc6e75b8ec02f0b2e153f5683e93b564daa358a163f6662cbf45cb92',
  platform: 'web-admin',
  clientPortalURL: 'https://stagclient.rockwell-logic.ie',
  appInsightsConnectionString: 'InstrumentationKey=038d9121-3bd0-4213-8b0d-25b5721109fb;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=22f4bc36-10c8-49c2-bc03-197aeff51664',
};
